import React, { useState, useEffect } from "react";
import api from "../../../../../../core/services/api";
import { useStyles } from "./styles";

//custom components
import GraphCard from "./GraphCard";

//material ui
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";

function PercentTransitTimeRoute(props) {
  const classes = useStyles();
  const [state, setState] = useState({
    series: [
      {
        data: [],
      },
    ],
    legends: [],
  });
  useEffect(() => {
    getData();
  }, [props.start_day, props.end_day,props.routes]);

  async function getData() {
    try {
      const data = await api.get(
        `sla-transit-route?start_at=${props.start_day}&end_at=${props.end_day}&routes=[${props.routes}]`
      );
      let transit = data.data.data.data || [];
      let legends = [];
      let series = [
        {
          name: "Transit Time por Rota",
          data: [],
        },
      ];
      transit.forEach((item, index) => {
        legends.push(item.route);
        series[0].data.push(parseFloat(item.percent_above));
      });

      setState((prev) => ({
        ...prev,
        series: series,
        legends: legends,
      }));
    } catch (error) {
      console.warn(error);
    }
  }
  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          % Transit Time por Rota
        </Typography>
        <GraphCard series={state.series} legends={state.legends} />
      </CardContent>
    </Card>
  );
}

export default PercentTransitTimeRoute;
